export class Warning {
  constructor(
    public message: string,
    public blockerInd: boolean = false
  ) {}
}
